import React, { useEffect } from "react";
import { Col, Row, Card, Tag, Space, Button, Progress, Flex, Breadcrumb, Alert } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import courseService from "../util/course";
import { getImageURL } from "../util/images";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseItemAsync, resetStatus, saveProgressAsync, selectCourse } from "../features/courses/coursesSlice";
import CourseService from "../util/course";
import { WysiwygDisplay } from "../components/WysiwygDisplay";
import useAuth from "../hooks/useAuth";

export default function CourseItem() {
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const data = useSelector((state) => selectCourse(state));
  const status = useSelector((state) => state.courses.status);
  const error = useSelector((state) => state.courses.error);
  const org = useSelector((state) => state.organisation.organisation);
  const manualApprovalEnabled = org?.attributes?.LMS.enable_manual_approval;

  useEffect(() => {
    if (status === "idle" || (status === "fulfilled" && !data) || data?.id !== id) {
      dispatch(fetchCourseItemAsync(id));
    }
  }, [dispatch, status, data, id]);

  if (status === "pending" || !data) return <div className="AlertInfo Loading">Loading...</div>;
  if (error) return <p>Error :(</p>;

  const startCourse = () => {
    if (data.attributes.started) return navigate(`/courses/${id}/lessons`);

    dispatch(
      saveProgressAsync({
        id,
        data: {
          ...data.attributes,
          started: true,
        },
      })
    );
    dispatch(resetStatus());
    navigate(`/courses/${id}/lessons`);
  };

  const tags = courseService.getTags(data.attributes.course.data).join(", ");
  const isUserConfirmed = manualApprovalEnabled ? auth.getUser().confirmed && auth.getUser().isUserApproved : true;

  return (
    <div className="CourseSingle PageSingle">
      <div className="AppContainer">
        <Breadcrumb
          className="Breadcrumb"
          items={[
            {
              title: <Link to="/">Home</Link>,
            },
            {
              title: <Link to="/courses">My Courses</Link>,
            },
            {
              title: data.attributes.course.data.attributes.Title,
            },
          ]}
        />
        <Row gutter={[20, 20]}>
          <Col xs={{ span: 24, order: 2 }} md={{ span: 16, order: 1 }}>
            <Card bordered={false} className="CardItem">
              <h1 className="title">{data.attributes.course.data.attributes.Title}</h1>
              <Space size={[0, 8]} wrap className="TagContainer">
                {tags && <Tag>{tags}</Tag>}
                <Tag>{courseService.getLessonCount(data.attributes.course.data)} Lessons</Tag>
                <Tag>{courseService.getQuizCount(data.attributes.course.data)} Assessments</Tag>
              </Space>
              <WysiwygDisplay data={data.attributes.course.data.attributes.Description} />
              <div>
                <h3>Course Contents</h3>
                <ul>
                  {data.attributes.course.data.attributes.Lessons.map((lesson) => (
                    <li key={lesson.id}>
                      {lesson.__typename === "ComponentCoursesQuizzes" ? <span style={{ fontWeight: 600 }}>Quiz: </span> : ""}
                      {lesson.title}
                    </li>
                  ))}
                </ul>
              </div>
              {!isUserConfirmed && <div className="HideContent"></div>}
            </Card>
          </Col>
          <Col xs={{ span: 24, order: 1 }} md={{ span: 8, order: 2 }}>
            <Card
              bordered={false}
              className="CardItem"
              cover={<img alt="" src={getImageURL(data.attributes.course.data.attributes.Cover.data?.attributes.url)} />}
            >
              {data.attributes.started && (
                <div className={`CardProgress ${CourseService.calculateProgress(data) === "100" ? "completed" : "null"}`}>
                  <Progress percent={CourseService.calculateProgress(data)} />
                </div>
              )}

              {!isUserConfirmed && <Alert className="AppAlert Small" message="Confirm account to unlock" type="error" />}
              <Flex justify="center" align="center">
                <Button type="primary" onClick={startCourse} disabled={!isUserConfirmed}>
                  {data.attributes.started ? "Continue Learning" : "Start Now"}
                </Button>
              </Flex>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
